import React from "react";
import config from "../../config";

export function TitleBreadcrumb({ title = "Werfklas", subtitle = "Dashboard", showEnv = true, variant = "default" }) {
  const isLocal = showEnv && config.environment === "development";

  const headingClass =
    variant === "parent"
      ? "text-2xl font-bold dark:text-emerald-300"
      : "text-2xl font-bold text-indigo-700 dark:text-indigo-300";
  const headingStyle = variant === "parent" ? { color: "var(--parent-primary)" } : undefined;

  return (
    <div className="flex flex-col gap-3 sm:flex-row sm:items-center sm:justify-between">
      <h1 className={headingClass} style={headingStyle}>
        {title} <span className="text-gray-600 dark:text-gray-400">| {subtitle}</span>
      </h1>

      {isLocal && (
        <span className="inline-flex items-center rounded-full bg-orange-100 px-3 py-1 text-xs font-semibold uppercase tracking-wide text-orange-700 dark:bg-orange-900/40 dark:text-orange-200">
          LOCALHOST
        </span>
      )}
   </div>
 );
}
